export default __webpack_public_path__ + "static/media/home-creative-agency-bg-img-03.9e2c4857.jpg";